<template>
  <div class="katex-container" ref="katex-container" v-html="content"></div>
</template>
<script>
const options = {
  delimiters: [
    { left: "$$", right: "$$", display: true },
    { left: "$", right: "$", display: false },
    { left: "\\(", right: "\\)", display: false },
    { left: "\\[", right: "\\]", display: true },
  ],
  output: "html",
};

import autoRender from "katex/contrib/auto-render/auto-render";

export default {
  props: {
    content: {
      type: String,
      default: "",
    },
    options: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    content: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.katexRender();
          });
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // this.katexRender();
  },
  methods: {
    katexRender() {
      if (this.$refs["katex-container"]) {
        autoRender(
          this.$refs["katex-container"],
          Object.assign({}, options, this.options)
        );
      }
    },
  },
};
</script>
<style scoped lang="scss">
.katex-container ::v-deep {
  white-space: pre-wrap;
  h1 {
    font-size: 1.5em;
    font-weight: bold;
    margin: 0.83em 0;
  }
  h2 {
    font-size: 1.3em;
    font-weight: bold;
    margin: 0.67em 0;
  }
  h3 {
    font-size: 1.17em;
    font-weight: bold;
    margin: 0.5em 0;
  }
  h4 {
    font-size: 1em;
    font-weight: bold;
    margin: 0.25em 0;
  }
  h5 {
    font-size: 0.83em;
    font-weight: bold;
    margin: 0.17em 0;
  }
  ul {
    margin: 0.5em 0;
  }
  li {
    margin: 0.5em 0;
  }
}
</style>
